import { render, staticRenderFns } from "./EditVideoCourse.vue?vue&type=template&id=046656d8&scoped=true"
import script from "./EditVideoCourse.vue?vue&type=script&lang=js"
export * from "./EditVideoCourse.vue?vue&type=script&lang=js"
import style0 from "./EditVideoCourse.vue?vue&type=style&index=0&id=046656d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046656d8",
  null
  
)

export default component.exports